"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessage = void 0;
const react_1 = __importDefault(require("react"));
const lab_1 = require("@material-ui/lab");
const ErrorMessage = (props) => {
    const { error } = props;
    if (!error)
        return null;
    return react_1.default.createElement(lab_1.Alert, { severity: "error" }, error);
};
exports.ErrorMessage = ErrorMessage;
//# sourceMappingURL=index.js.map